angular
  .module("tipologiaAccesso.components", [])
  .component("tipologiaAccesso", {
    templateUrl: "ng/components/tipologiaAccesso/tipologiaAccesso.html",
    bindings: {
      gestioneFornitori: "<",
      verificato: "=",
    },
    controllerAs: "tipologiaAccessoCtrl",
    controller: function tipologiaAccesso($financialService, $configService, $rootScope) {
      var self = this;

      self.$onInit = function () {
        self.options = ["2FA", "VPN"];
        self.optionSelected = self.gestioneFornitori.switchLoginAgent
          .existTypeAgentLogin
          ? self.gestioneFornitori.switchLoginAgent.existTypeAgentLogin
          : "2FA";
        self.verifica = {
          verificato: self.gestioneFornitori.switchLoginAgent.verificato,
          verificatoUtente: self.gestioneFornitori.switchLoginAgent.utente,
          verificatoDataConferma:
            self.gestioneFornitori.switchLoginAgent.dataConferma,
        };
        self.enableTipologiaAccesso =
          $configService.getAppConfig().user.type == "ARA_PROFILI"
            ? true
            : false;
      };

      self.changeOption = function (value) {
        self.optionSelected = value;
        self.gestioneFornitori.switchLoginAgent.switchTypeAgentLogin = value;
      };

      self.confirmOption = function () {
        self.gestioneFornitori.switchLoginAgent.switchTypeAgentLogin =
          self.optionSelected;
        self.isConfirmingOption = true;
        $financialService
          .changeAgentLogin(self.gestioneFornitori)
          .then(function (response) {
            if (response.success) {
              self.verifica.verificato = response.verificato;
              self.verifica.verificatoUtente = response.utente;
              self.verifica.verificatoDataConferma = response.dataConferma;
              self.gestioneFornitori.switchLoginAgent.verificato =
                response.verificato;
              self.gestioneFornitori.switchLoginAgent.utente = response.utente;
              self.gestioneFornitori.switchLoginAgent.dataConferma =
                response.dataConferma;
              $rootScope.$broadcast("addAlert", {
                text: "ACCESSO_AGENTE_OK",
              });
            }
            self.isConfirmingOption = false;
          })
          .catch(function (err) {
            self.isConfirmingOption = false;
            console.log(err);
          });
      };
    },
  });
